import LOGO from './../../assets/logo-cropped.png';
import User from './../../assets/user.png'
import './Header.scss';
import { useState } from 'react';
import { useUser } from '../../context/UserProvider';
import { Button } from 'primereact/button';
import { useAuth } from '../../hooks/Auth';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';


export default function Header() {
    const [open, setOpen] = useState(false);
    const { user, login } = useUser();
    const { logOut, authenticateUser } = useAuth();

    const [form, setForm] = useState({
        email: '',
        password: ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const isAuthenticated = await authenticateUser({ email: form.email, password: form.password })
        if (isAuthenticated) {
            login(isAuthenticated.data);
            setOpen(false);
        } else {
            console.error("Login failed");
        }
    }

    const handleOAuth = () => {
        window.location.href = process.env.REACT_APP_API_URL + "/oauth2/authorization/google";
    }

    return (
        <>
            {/* <LoginModal open={open} setOpen={setOpen} /> */}
            <Dialog visible={open} style={{ width: '50vw' }} onHide={() => { if (!open) return; setOpen(false); }}>
                <p className="m-0">
                    <form onSubmit={handleSubmit}>
                        <Button type='button' onClick={handleOAuth}>Sign in with Google</Button>
                    </form>
                </p>
            </Dialog>
            <div className='header'>
                <div className="header-main">
                    <div className="header-main-logo">
                        <img onClick={() => { window.location.href = "/dashboard" }} src={LOGO} alt="Indian Express Logo" />
                    </div>
                    <div className='header-main-title'>
                        <p onClick={() => { window.location.href = "/dashboard" }}>इंडिया एक्सप्रेस</p>
                    </div>
                    <div className='header-user'>
                        {user ?
                            <>
                                <Tooltip target=".user" position="mouse" content={user.email} />
                                <p>{user.givenName}</p>
                                <div>
                                    <img className='user' src={user?.pictureURL || User} alt="User Profile" height={45} />
                                </div>
                                <Button className='gen-button' type='button' label='Log Out' onClick={logOut} />
                            </> :
                            <>
                                <img className='user' src={User} alt="User Profile" height={45} />
                                <Button className='gen-button' label='Log In' severity='Primary' onClick={() => setOpen(true)} />
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className='header-links-container'>
                <div className="header-links">
                    <span className="header-link"><a href='#'>होम</a></span>
                    <span className="header-link"><a href='#'>राजनीति</a></span>
                    <span className="header-link"><a href='#'>उत्तर प्रदेश</a></span>
                    <span className="header-link"><a href='#'>उत्तराखंड</a></span>
                    <span className="header-link"><a href='#'>राजस्थान</a></span>
                    <span className="header-link"><a href='#'>हरियाणा</a></span>
                    <span className="header-link"><a href='#'>पंजाब</a></span>
                    <span className="header-link"><a href='#'>बिहार</a></span>
                    <span className="header-link"><a href='#'>दिल्ली</a></span>
                    <span className="header-link"><a href='#'>पश्चिमी उत्तर प्रदेश</a></span>
                    <span className="header-link"><a href='#'>खेल</a></span>
                    <span className="header-link"><a href='#'>खेती किसानी</a></span>
                    <span className="header-link"><a href='#'>बिजनेस</a></span>
                    <span className="header-link"><a href='#'>लाइफस्टाइल</a></span>
                </div>
            </div>
        </>
    );
}